// ABOUTME: Renders a select dropdown for ItemPositionType (Mandatory/Optional/Merchandise) in CGT items link field.
// ABOUTME: Stores the selected position type in the extraInfo state for the row.

import { MenuItem, Select } from '@ds/coolshop';
import type { DataTableRow } from '@ds/data-table';
import { ItemPositionType } from '@src/__generated__/types';
import type { Row } from '@tanstack/react-table';
import { type Dispatch, type SetStateAction, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

type GridCellPositionTypeRendererProps = {
    row: Row<DataTableRow>;
    extraInfo: Record<string, string>[] | undefined;
    setExtraInfo: Dispatch<SetStateAction<Record<string, string>[] | undefined>>;
};

export function GridCellPositionTypeRenderer(props: GridCellPositionTypeRendererProps) {
    const { row, extraInfo, setExtraInfo } = props;

    const intl = useIntl();

    const rowVal = extraInfo?.find(r => r.id === row.id);
    const [val, setVal] = useState(rowVal?.positionType ?? ItemPositionType.Mandatory);

    const options = useMemo(
        () => [
            {
                key: ItemPositionType.Mandatory,
                label: intl.formatMessage({ id: 'mandatory', defaultMessage: 'Obbligatorio' }),
            },
            {
                key: ItemPositionType.Optional,
                label: intl.formatMessage({ id: 'optional', defaultMessage: 'Opzionale' }),
            },
            {
                key: ItemPositionType.Merchandise,
                label: intl.formatMessage({ id: 'merchandise', defaultMessage: 'Merchandise' }),
            },
        ],
        [],
    );

    return (
        <Select
            fullWidth
            size="small"
            value={val}
            onChange={e => setVal(e.target.value)}
            onBlur={() =>
                setExtraInfo(prev => [
                    ...(prev ?? []).filter(r => r.id !== row.id),
                    { ...rowVal, id: row.id, positionType: val },
                ])
            }
        >
            {options.map(o => (
                <MenuItem key={o.key} value={o.key}>
                    {o.label}
                </MenuItem>
            ))}
        </Select>
    );
}
